import { colors } from 'design-system';
import { makeStyles, Tab, Tabs } from '@material-ui/core';
import { uniqueId } from 'lodash';

const useStyles = makeStyles(() => ({
  tabDirection: {
    flexDirection: 'row',
    color: colors.madison,
    '& img, svg': {
      marginRight: 10,
    },
  },
  tabIndicator: {
    backgroundColor: colors.bright_turquoise,
    height: 4,
  },
  tabSelected: {
    minHeight: 0,
    opacity: 1,
    '&.Mui-selected': {
      backgroundColor: colors.cloud,
    },
  },
  tabRoot: {
    borderBottom: `1px solid ${colors.onahau}`,
  },
}));

export const TabSelectProductType = (): JSX.Element => {
  const classes = useStyles();

  return (
    <Tabs
      data-testid="tabs"
      value="vehicle"
      classes={{
        root: classes.tabRoot,
        indicator: classes.tabIndicator,
      }}
    >
      <Tab
        label="COBERTURA COMPLETA"
        value="vehicle"
        icon={<img src="svg/completeVehicleCar.svg" alt="cobertura_completa" />}
        key={uniqueId()}
        classes={{
          wrapper: classes.tabDirection,
          textColorInherit: classes.tabSelected,
        }}
      />
    </Tabs>
  );
};

export default TabSelectProductType;
